import ArrowSubtitle from "../ArrowSubtitle/ArrowSubtitle";
import styles from "./WhiteTextSection.module.css";
import useIntersectionObserver from "../../hooks/useIntersectionObserver";

function WhiteTextSection({ arrowText, children, style, reference }) {
    const [ref, , fadeClassName] = useIntersectionObserver(0.5);

    return (
        <section
            ref={(el) => {
                ref.current = el;
                if (reference) reference.current = el;
            }}
            id={styles.section}
            style={style}
        >
            <div id={styles.container} className={fadeClassName}>
                <ArrowSubtitle text={arrowText} dark={true} />
                <h2 id={styles.text}>{children}</h2>
            </div>
        </section>
    );
}

export default WhiteTextSection;
